import { createLoader } from '@meteor/data-hooks';
import { instanceClient } from '../../instance/client';
import { withAuth } from '../../user';
import { organizationClient } from '../client';
import { organizationLoader, organizationsLoader } from './organization';

export let projectLoader = createLoader({
  name: 'organizationProject',
  parents: [organizationsLoader, organizationLoader],
  fetch: async (i: { projectId: string }) => {
    let orgs = await organizationsLoader.fetchAndReturn();
    let org = orgs.find(o => o.projects.some(p => p.id === i.projectId));

    return withAuth(() =>
      organizationClient.project.get({
        ...i,
        organizationId: org?.id ?? ''
      })
    );
  },
  mutators: {
    update: (
      i: {
        name?: string;
      },
      { input: { projectId }, output: { organizationId } }
    ) =>
      withAuth(() =>
        organizationClient.project.update({
          organizationId,
          projectId,
          ...i
        })
      ),

    delete: (i: void, { input: { projectId }, output: { organizationId } }) =>
      withAuth(() =>
        organizationClient.project.delete({
          organizationId,
          projectId
        })
      ),

    createInstance: (
      i: {
        name?: string;
        environment: 'development' | 'production';
      },
      { input: { projectId }, output: { organizationId } }
    ) =>
      withAuth(() =>
        instanceClient.instance.create({
          organizationId,
          projectId,
          ...i
        })
      )
  }
});

export let useProject = (projectId: string | undefined | null) => {
  let project = projectLoader.use(projectId ? { projectId } : null);

  return {
    ...project,
    updateMutator: project.useMutator('update'),
    deleteMutator: project.useMutator('delete'),
    createInstanceMutator: project.useMutator('createInstance')
  };
};
